import type { StatColumn, SeasonStats } from '@/components/mlb-beta/statsTableDefs';

interface StatStripProps {
  columns: StatColumn[];
  stats: SeasonStats | null;
  statView: 'season' | 'pergame';
  gamesPlayed: number;
}

export function StatStrip({ columns, stats, statView, gamesPlayed }: StatStripProps) {
  if (columns.length === 0) return null;

  const isPerGame = statView === 'pergame';

  return (
    <div className="grid grid-cols-5 px-3 py-1.5 border-t border-border/60 bg-[hsl(222_47%_5%)]">
      {columns.map((col) => {
        const counting = !col.isRate;
        const rawValue = col.getValue(stats);
        const label = isPerGame && counting ? `${col.label}/G` : col.label;

        let displayValue: string | number = rawValue;
        if (isPerGame && counting && typeof rawValue === 'number' && gamesPlayed > 0) {
          displayValue = (rawValue / gamesPlayed).toFixed(1);
        }

        return (
          <div key={col.key} className="flex flex-col items-center min-w-0">
            <span className="text-[9px] uppercase tracking-wider text-muted-foreground/70">
              {label}
            </span>
            <span className="font-display font-bold text-[13px] tabular-nums text-foreground">
              {displayValue}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default StatStrip;
